import React from 'react';

import {
  Datasets,
}                               from '.';

const catalogFilter = (resource) => {
  return (resource.CatalogConfiguration && resource.CatalogConfiguration.Status === 'ENABLED');
};

export default function Catalog(props) {

  const columnDefs = [
    { name: 'CatalogConfiguration.DatabaseName', label: "Database Name", options: { display: true } },
    { name: 'ResourceId', options: { display: false } },
    { name: 'ClientAccountId', options: { display: false } },
    { name: 'Description', options: { display: true } },
    { name: 'Metrics.Inventory.Latest.Data.TotalObjectBytes', options: { display: true } },
    { name: 'Metrics.Inventory.Latest.Data.TotalObjects', options: { display: false } },
    { name: 'Metrics.Activity.LastUpdate', options: { display: true } },
    { name: 'Metrics.Crawl.Latest.Data.Completed', options: { display: true } },
    { name: 'Metrics.Crawl.Latest.Data.Status', options: { display: true } },
    { name: 'Metrics.Crawl.Latest.Data.RunTimeSecs', options: { display: true } },
    { name: 'CatalogConfiguration.Cooldown', options: { display: true } },
    { name: 'SecurityConfiguration.AuthorizedReadOnlyAccountIds', options: { display: true } },
    { name: 'Metrics.CloudWatch.Latest.Data.BytesDownloaded.Value', options: { display: false } },
    { name: 'Metrics.CloudWatch.Latest.Data.BytesUploaded.Value', options: { display: false } },
    { name: 'Metrics.CloudWatch.Latest.Data.Requests.Value', options: { display: false } },
    { name: 'Location.S3Uri', options: { display: false } },
    { name: 'CatalogConfiguration.Status', options: { display: false, filter: false } },
  ];

  return (
    <Datasets 
      title='Databases' 
      filter={catalogFilter}
      columnDefs={columnDefs}
    />
  );
}

Catalog.propTypes = {
};

Catalog.defaultProps = {
};
